import React from 'react';
import { motion } from 'framer-motion';
import { gallery, vibeImage } from '../data/party';
export function Gallery() {
  return <section className="w-full bg-[var(--terracotta)] px-5 py-24" data-id="element-14" data-mp="34bwzrw3wju67">
      <div className="mx-auto max-w-5xl" data-id="element-15" data-mp="3ichiytdqbs08">
        <h2 className="font-display mb-14 text-center text-5xl uppercase text-[var(--cream)] sm:text-7xl" data-id="element-16" data-mp="3ibg5ki98qtfc">
          The Vibe
        </h2>

        <motion.div initial={{
        opacity: 0,
        y: 28
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.55
      }} className="mb-4 overflow-hidden rounded-3xl" data-id="element-17" data-mp="2pnakfue9z2ez">
          <img src={vibeImage.src} alt={vibeImage.alt} className="block h-auto w-full" data-id="element-18" data-mp="2zeyabqv6obec" />
        </motion.div>

        <div className="columns-1 gap-4 sm:columns-2 lg:columns-3 [&>*]:mb-4" data-id="element-19" data-mp="2ukk7x4i3t406">
          {gallery.map((img, i) => <motion.div key={img.src} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.45,
          delay: i % 3 * 0.08
        }} className="overflow-hidden rounded-2xl" data-id="element-20" data-mp="21xzhc69gcvxo" data-mpi={i}>
              <img src={img.src} alt={img.alt} loading="lazy" className="block h-auto w-full transition-transform duration-500 hover:scale-[1.03]" data-id="element-21" data-mp="111ukmxqe7t3m" />
            </motion.div>)}
        </div>
      </div>
    </section>;
}